import React, { memo } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { DayPicker } from '../index'
import { useDatePickerStyles } from './styles'
import { useI18n } from '~/core/i18n'

const DayTimePicker = ({ id, value, disabled, type, isDayOptionDisabled, onChange, ...props }) => {
  const [msg] = useI18n()
  const classes = useDatePickerStyles()

  return (
    <div className={classes.dayTimePicker} {...props}>
      <div className={classes.daySelect}>
        <DayPicker
          disabled={disabled}
          isDayDisabled={weekDay => isDayOptionDisabled(weekDay, value)}
          placeholder={msg('common.datePicker.daysSelect')}
          value={value ? moment(value).isoWeekday() : null}
          onChange={weekDay => {
            const prevTime = value ? moment(value) : moment()[type]('day')
            return onChange({
              id,
              value: prevTime.isoWeekday(weekDay).toISOString()
            })
          }}
        />
      </div>
      <input
        className={classes.timeSelect}
        disabled={disabled}
        placeholder={msg('common.datePicker.time')}
        type="time"
        value={
          value
            ? moment(value).format('HH:mm')
            : moment()
                [type]('day')
                .format('HH:mm')
        }
        onChange={({ target }) => {
          const [hours, minutes] = target.value.split(':')
          onChange({
            id,
            value: moment(value || undefined)
              .set({
                hours: Number(hours),
                minutes: Number(minutes),
                seconds: 0,
                milliseconds: 0
              })
              .toISOString()
          })
        }}
      />
    </div>
  )
}

DayTimePicker.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isDayOptionDisabled: PropTypes.func,
  type: PropTypes.oneOf(['startOf', 'endOf']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]).isRequired,
  onChange: PropTypes.func.isRequired
}

DayTimePicker.defaultProps = {
  type: 'startOf',
  isDayOptionDisabled: () => {},
  onChange: () => {}
}

export default memo(DayTimePicker)
